module.exports = __webpack_public_path__ + "static/media/poster-header.bb411c86.png";